import React from "react";
import Card from "../shared/Card";

const PanelStatistics = ({ panel, documents = [], panelists = [] }) => {
  const calculateDaysUntilDeadline = (deadline) => {
    if (!deadline) return 0;
    return Math.max(
      0,
      Math.ceil((new Date(deadline) - new Date()) / (1000 * 60 * 60 * 24))
    );
  };

  const stats = [
    {
      label: "Documents",
      value: documents.length,
    },
    {
      label: "Panelists",
      value: panelists.length,
    },
    {
      label: "Days Until Deadline",
      value: calculateDaysUntilDeadline(panel?.deadline),
      highlight: true,
    },
    {
      label: "Community",
      value: panel?.community || "N/A",
    },
  ];

  return (
    <Card title="Panel Statistics">
      <div className="space-y-3">
        {stats.map((stat, index) => (
          <div key={index} className="flex justify-between items-center">
            <span className="text-sm text-gray-600">{stat.label}</span>
            <span
              className={`font-medium ${
                stat.highlight ? "text-orange-600" : "text-gray-900"
              }`}
            >
              {stat.value}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default PanelStatistics;
